import { Building2, Check, ChevronsUpDown } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuShortcut,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { SidebarMenuButton, SidebarMenuItem } from '@/components/ui/sidebar';
import { useOrganization } from '@/contexts/OrganizationContext';
import { useDeferredOrganizationSwitch } from './UseDeferredOrganizationSwitch';

export const OrganizationSwitcher = () => {
  const { selectedOrganizationId, availableOrganizations, isLoading } = useOrganization();
  const switchOrganization = useDeferredOrganizationSwitch();

  const selectedOrganization = availableOrganizations.find((org) => org.id === selectedOrganizationId);

  if (isLoading || availableOrganizations.length === 0) {
    return (
      <SidebarMenuItem className="flex justify-center">
        <SidebarMenuButton tooltip="Loading...">
          <Building2 className="size-6" />
          <span className="font-body font-medium text-sm group-data-[collapsible=icon]:hidden">Loading...</span>
        </SidebarMenuButton>
      </SidebarMenuItem>
    );
  }

  // If only one organization, just display it without dropdown
  if (availableOrganizations.length === 1) {
    return (
      <SidebarMenuItem className="flex justify-center">
        <SidebarMenuButton tooltip={selectedOrganization?.name}>
          <Building2 className="size-6" />
          <span className="truncate font-body font-medium text-sm group-data-[collapsible=icon]:hidden">
            {selectedOrganization?.name}
          </span>
        </SidebarMenuButton>
      </SidebarMenuItem>
    );
  }

  return (
    <SidebarMenuItem className="flex justify-center">
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <SidebarMenuButton tooltip={selectedOrganization?.name ?? 'Select Organization'}>
            <Building2 className="size-6" />
            <span className="flex-1 truncate font-body font-medium text-sm group-data-[collapsible=icon]:hidden">
              {selectedOrganization?.name ?? 'Select Organization'}
            </span>
            <ChevronsUpDown className="ml-auto size-4 shrink-0 group-data-[collapsible=icon]:hidden" />
          </SidebarMenuButton>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="start" className="min-w-60" side="bottom" sideOffset={4}>
          <DropdownMenuGroup>
            <DropdownMenuLabel>
              Organisations
              <DropdownMenuShortcut className="ml-2">{availableOrganizations.length}</DropdownMenuShortcut>
            </DropdownMenuLabel>
            {availableOrganizations.map((org) => (
              <DropdownMenuItem
                className="cursor-pointer"
                key={org.id}
                onClick={() => {
                  switchOrganization(org.id);
                }}
              >
                <Check className={org.id === selectedOrganizationId ? 'opacity-100' : 'opacity-0'} />
                {org.name}
              </DropdownMenuItem>
            ))}
          </DropdownMenuGroup>
        </DropdownMenuContent>
      </DropdownMenu>
    </SidebarMenuItem>
  );
};
